import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form } from "../../../components/forms";

const GoToProfilePopup = ({ show, onClose }) => {
  const navigate = useNavigate();
  const [count, setCount] = useState(5);

  useEffect(() => {
    if (count <= 0) {
      handleNavigate();
      onClose();
      return
    }

    const timer = setTimeout(() => {
      setCount((prevCount) => prevCount - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [count]);

  if (!show) return null;

  const handleNavigate = () => navigate("/user/order", { replace: true });

  return (
    <Form initialValues={{ message: "" }} enableReinitialize className="d-flex">
      <div className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100 bg-black bg-opacity-50 popup">
        <div className="bg-white rounded p-4 pb-5 shadow-lg inner-box">
          <div className="d-flex flex-row align-items-center justify-content-between mx-1 mx-md-4">
            <h5 className="text-primary-600 mb-0 fw-bold">
              Your document has been successfully submitted!
            </h5>
          </div>
          <hr className="hr-popup mt-4 mb-5" />
          <div className="modal-body mx-1 mx-md-4">
            <div className="container px-0 d-flex flex-column justify-content-between">
              <p className="mb-1">
                You will be redirected to your profile shortly. Alternatively, click the button below to “go to your profile” now.
              </p>
              <p className="text-gray-1 mb-4">
                {`Redirecting in ${count}...`}
              </p>
            </div>

            <div className="d-flex flex-column-reverse flex-md-row justify-content-end align-items-center px-5 px-md-0 py-4 py-md-0">
              <button
                className="bg-primary-600 text-white py-2 px-5 w-fit h-fit fw-bold fs-6 border-0 rounded text-nowrap"
                onClick={handleNavigate}
              >
                Go to my profile
              </button>
            </div>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default GoToProfilePopup;
